import React, { useEffect, useMemo, useState } from "react";
import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import ContentHeader from "../../../components/shared/ContentHeader";
import BranchesUserCards from "./BranchesUserCards";
import { AdvisorContainer } from "./styles";
import { useTenantBranches } from "../../../hooks/useTenantBranches";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedTenantId } from "../../../store/user/selectors";
import { getBranchesUsers } from "../../../store/branch/thunks";

const Advisor = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const {
    branches,
    loading,
    branchState: { branchUsersLoading },
  } = useTenantBranches();

  const dispatch = useDispatch();

  const selectedTenantId = useSelector(selectSelectedTenantId);

  useEffect(() => {
    if (!selectedTenantId || loading || !Array.isArray(branches)) return;
    const hasBranchWithoutUsers = branches.some(
      (branch) => !Array.isArray(branch.users),
    );

    if (hasBranchWithoutUsers) {
      dispatch(getBranchesUsers({ tenant_id: selectedTenantId }));
    }
  }, [selectedTenantId, branches, loading]);

  const filteredBranches = useMemo(
    () =>
      branches.filter(({ name }) =>
        name.toLowerCase().includes(searchTerm.toLowerCase()),
      ),
    [branches, searchTerm],
  );

  return (
    <AdvisorContainer>
      <ContentHeader title={"Branch - Advisor Management"}>
        <Input
          placeholder="Search branches..."
          prefix={<SearchOutlined />}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </ContentHeader>
      <BranchesUserCards
        filteredBranches={filteredBranches}
        loading={loading}
        branchUsersLoading={branchUsersLoading}
      />
    </AdvisorContainer>
  );
};

export default Advisor;
